function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_883",
  "data-name": "Group 883",
  transform: "translate(-1109.005 -1785.031)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_648",
  "data-name": "Group 648",
  transform: "translate(622 800)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_641",
  "data-name": "Group 641",
  transform: "translate(1.396 1.396)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_135",
  "data-name": "Ellipse 135",
  transform: "translate(493.604 993.604)",
  fill: "#fff",
  stroke: "#a3a3a3",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 16.5,
  r: 16.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 16.5,
  r: 16,
  fill: "none"
}))), /*#__PURE__*/React.createElement("text", {
  id: "_",
  "data-name": "+",
  transform: "matrix(0.719, 0.695, -0.695, 0.719, 519.654, 985.031)",
  fill: "#292929",
  fontSize: 35,
  fontFamily: "Nunito-SemiBold, Nunito",
  fontWeight: 600,
  opacity: 0.48
}, /*#__PURE__*/React.createElement("tspan", {
  x: 2.705,
  y: 35
}, "+"))));

var SvgRemoveIcon = function SvgRemoveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52.071,
    height: 52.565,
    viewBox: "0 0 52.071 52.565",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-icon.0df8cf06.svg";
export { ForwardRef as ReactComponent };